import React, { useEffect, useState } from "react";
import SideBar from "../../Common/SideBar";
import { useDispatch, useSelector } from "react-redux";
import "./styles/AllProjectsScreen.css";
import { projectStatus } from "../../../utils";
import PostedProjectTable from "./Components/PostedprojectsTable";
import ActiveProjectTable from "./Components/ActiveprojectsTable";
import CompleteProjectTable from "./Components/CompleteprojectsTable";

export default function AllProjectScreen() {
  const [activeTab, setActiveTab] = useState("POSTED");

  const sidebar = useSelector((state) => state.sidebar);
  return (
    <div className="MainContainer">
      <SideBar />
      <div
        style={{ width: sidebar.expand ? "84vw" : "95vw" }}
        className="ScreenContainer"
      >
        {/* upper search bar start */}

        <div className="upperSearchBarContainer">
          <div className="upperBarSearchBar">
            <div className="pageHeadingInnerContainer">
              {/* <img
                src={require("../../../assets/dashboardColourIcon.png")}
                alt="profile-pic"
                className="pageHeadingImageDashboard"
              /> */}
              <div className="pageHeading">All Projects</div>
            </div>
          </div>

          <div
            className="upperBarSearchBox upperBarSearchBoxProfile"
            style={{ border: "none" }}
          >
            <img
              src={require("../../../assets/profile.png")}
              alt="profile-pic"
            />
          </div>
          <div className="upperBarSearchBox upperBarSearchBoxNotification">
            <img
              src={require("../../../assets/exit.png")}
              alt="notification-bell"
            />
          </div>
        </div>
        <div
          className="upperSearchBarContainer"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "1.5vh",
          }}
        >
          <input placeholder="Search..." className="upperBarSearchBarInput" />
          <div className="searchButton">Search</div>
        </div>

        {/* upper search bar ends */}

        <div className="projectStatusTab">
          <div
            className={
              activeTab == projectStatus.POSTED
                ? "projectCategoryButton activeProjectCategoryButton"
                : "projectCategoryButton projectCategoryButtonInactive"
            }
            onClick={() => setActiveTab(projectStatus.POSTED)}
          >
            Posted
          </div>
          <div
            className={
              activeTab == projectStatus.ACTIVE
                ? "projectCategoryButton activeProjectCategoryButton"
                : "projectCategoryButton projectCategoryButtonInactive"
            }
            onClick={() => setActiveTab(projectStatus.ACTIVE)}
          >
            Active
          </div>
          <div
            className={
              activeTab == projectStatus.COMPLETE
                ? "projectCategoryButton activeProjectCategoryButton"
                : "projectCategoryButton projectCategoryButtonInactive"
            }
            onClick={() => setActiveTab(projectStatus.COMPLETE)}
          >
            Completed
          </div>
        </div>
        {/* table starts here */}
        {activeTab == projectStatus.POSTED && <PostedProjectTable />}
        {activeTab == projectStatus.ACTIVE && <ActiveProjectTable />}
        {activeTab == projectStatus.COMPLETE && <CompleteProjectTable />}
        {/* table ends here */}
      </div>
    </div>
  );
}
